import MobileNavActionTypes from "./mobile-nav.types";

export const toggleNav = () => ({
  type: MobileNavActionTypes.TOGGLE_NAV,
});
